import { capitalize, computed } from 'vue';

import ChartActionId from '@/common/enums/chart-action-id.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import TimeGranularity from '@/common/enums/time-granularity.enum';
import ChartAction from '@/common/models/chart/ChartAction';
import ChartGroupAction from '@/common/models/chart/ChartGroupAction';
import i18n from '@/vueI18n';

const areI18nLanguageFilesLoaded = (): boolean => i18n.global.availableLocales.length > 1;

const defaultOptions = computed(
  () =>
    (options: string[]): ChartAction[] =>
      options.map(
        (value: string) =>
          new ChartAction(
            value,
            false,
            areI18nLanguageFilesLoaded()
              ? i18n.global.t(`messages.chartGroupActionInterval${capitalize(value)}`)
              : value,
          ),
      ),
);

const ChartIntervalGroupActions = (
  rank: number,
  isHighlighted: boolean,
  optionList: string[],
  selectedOption?: string,
  transform?: (list: number[]) => number,
): ChartGroupAction => {
  const options = optionList?.length
    ? defaultOptions.value(optionList).map((d: ChartAction) => ({
        ...d,
        isSelected: d.id === selectedOption,
        enabled: optionList.indexOf(d.id) > -1,
      }))
    : defaultOptions.value(optionList);

  return new ChartGroupAction(
    ChartActionId.INTERVAL,
    ChartGroupActionType.SELECTABLE,
    areI18nLanguageFilesLoaded() ? i18n.global.t('messages.chartGroupActionInterval') : 'Interval',
    rank,
    options,
    isHighlighted,
    true,
    transform,
  );
};

const DefaultChartIntervalActions = ChartIntervalGroupActions(3, false, Object.values(TimeGranularity));

const ChartIntervalGroupActionsUtils = {
  DefaultChartIntervalActions,
  ChartIntervalGroupActions,
};

export default ChartIntervalGroupActionsUtils;
